const isDataImage = (data: string): boolean => {
  return !!data && data.trim().startsWith('data:image');
};
const dummy = (): boolean => {
  // this method will be removed after more than one method will be implemented
  // otherwise building process is demanding for default export to be used
  return true;
};

export { isDataImage, dummy };
